import React, { useState } from 'react';
import { Box, Heading, Text } from 'rebass';

const DeeplinkTester = () => {
  const [input, setInput] = useState('');

  const urls = input.split('\n').filter((url) => url.trim() !== '');

  return (
    <Box maxWidth="800px" mx="auto" mt={4} mb={4} p={4}>
      <Heading as="h1" fontSize={4} mb={3} sx={{ fontFamily: "Menlo, 'IBM Plex Mono', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', 'Courier New', monospace" }}>
        Deep Link Tester
      </Heading>

      <Box
        as="textarea"
        placeholder="Enter URLs, one per line..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        sx={{
          width: '100%',
          height: '150px',
          p: 2,
          mb: 3,
          fontSize: 2,
          borderRadius: 2,
          border: '1px solid #ccc',
          resize: 'vertical',
          fontFamily: 'inherit'
        }}
      />

      <Box>
        <Heading as="h2" fontSize={3} mb={2} sx={{ fontFamily: "Menlo, 'IBM Plex Mono', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', 'Courier New', monospace" }}>
          Generated Links
        </Heading>
        {urls.map((url, index) => (
          <Text key={index} mb={2}>
            <Box
              as="a"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#2563eb', textDecoration: 'underline' }}
            >
              {url}
            </Box>
          </Text>
        ))}
      </Box>
    </Box>
  );
};

export default DeeplinkTester;
